// extracted by mini-css-extract-plugin
module.exports = {"text":"N3SxD","item":"_1slQp","attribute":"rSHVg","link":"SUBns"};